export default "/images/vendor/flag-icon-css/flags/4x3/ls.svg?0de0f907e70c37b2e86e25e29e4bdad4";